import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import base_resources from './translations/base'
import baseCAFlow_resources from './translations/base-ca-flow'
import baseUSFlow_resources from './translations/base-us-flow'
import cle_resources from './translations/cle'
import lcr_resources from './translations/lcr'
import vde_resources from './translations/vde-fr'
import nua_resources from './translations/nua'
import fde_resources from './translations/fde'
import ebd_resources from './translations/ebd'
import gdo_resources from './translations/gdo'
import gop_resources from './translations/gop'

const lang = 'en'

const resources = {
  en: {
    translation: {
      ...base_resources.en,
    },
    // fallback namespace for CA flow, takes precedence over default translation namespace
    translation_ca: {
      ...baseCAFlow_resources.en,
    }, // fallback namespace for US flow, takes precedence over default translation namespace
    translation_us: {
      ...baseUSFlow_resources.en,
    },
    cle: {
      ...cle_resources.en,
    },
    lcr: {
      ...lcr_resources.en,
    },
    vde: {
      ...vde_resources.en,
    },
    nua: {
      ...nua_resources.en,
    },
    fde: {
      ...fde_resources.en,
    },
    ebd: {
      ...ebd_resources.en,
    },
    gdo: {
      ...gdo_resources.en,
    },
    gop: {
      ...gop_resources.en,
    },
  },
  fr: {
    translation: {
      ...base_resources.fr,
    },
    translation_ca: {
      ...baseCAFlow_resources.fr,
    },
    translation_us: {
      ...baseUSFlow_resources.en,
    },
    cle: {
      ...cle_resources.fr,
    },
    lcr: {
      ...lcr_resources.fr,
    },
    vde: {
      ...vde_resources.fr,
    },
    nua: {
      ...nua_resources.en,
    },
    fde: {
      ...fde_resources.en,
    },
    ebd: {
      ...ebd_resources.en,
    },
    gdo: {
      ...gdo_resources.fr,
    },
    gop: {
      ...gop_resources.fr,
    },
  },
}

/**
 * Note: the fallbackNS is modified at runtime in WidgetApp based on the
 * brand locale. For example, for US flow - the fallbackNS will be set to
 *    ['translation_us', 'translation']
 * to give the translations_us namespace higher precedence over the default
 */
i18n.use(initReactI18next).init({
  resources,
  debug: process.env.NODE_ENV === 'development',
  lng: lang,
  fallbackNS: 'translation',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
